import Box from '@mui/material/Box';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export default withTheme(styled(Box)`
  .MuiList-root {
    padding-top: 0;
  }
`);
